import { render, staticRenderFns } from "./CalcIncome.vue?vue&type=template&id=279004c1"
import script from "./CalcIncome.vue?vue&type=script&lang=js"
export * from "./CalcIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports